import { type ServiceConfig } from '../../ServiceRegistry';
import BaseService from '@/services/BaseService';

/**
 * Reporting service configurations
 * These services are used by the reporting module
 */
export const reportingServices: ServiceConfig[] = [
  {
    name: 'reportService',
    factory: () => new BaseService('/api/reports'),
  },
  {
    name: 'reportGeneratorService',
    factory: () => new BaseService('/api/report-generator'),
  },
  {
    name: 'reportSchedulerService',
    factory: () => new BaseService('/api/reports/scheduler'),
  },
  {
    name: 'reportExportService',
    factory: () => new BaseService('/api/reports/export'),
  },
];

/**
 * Reporting-specific service factory
 * Creates a custom service with reporting-specific configuration
 */
export const createReportingCustomService = (serviceName: string, baseUrl: string = '/api/reports'): ServiceConfig => ({
  name: serviceName,
  factory: () => new BaseService(baseUrl),
});

/**
 * Reporting service utilities
 */
export const reportingServiceUtils = {
  /**
   * Get all reporting service names
   */
  getServiceNames: () => reportingServices.map(s => s.name),

  /**
   * Check if a service name is a reporting service
   */
  isReportingService: (name: string) => reportingServices.some(s => s.name === name),

  /**
   * Get reporting base path
   */
  getBasePath: () => '/securitization/reports',
};
